import type { TextFieldElementProps } from 'react-hook-form-mui';
import { useTranslation } from 'react-i18next';

import { TextField } from './TextField';

type Props = TextFieldElementProps & {
  name: string;
  label?: string;
};

export const PasswordField = ({ name, label, ...props }: Readonly<Props>) => {
  const { t } = useTranslation();

  return (
    <TextField
      {...props}
      type="password"
      name={name}
      label={label ?? t('auth.password')}
      isRequired
    />
  );
};
